import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { memo } from 'react';

import { leverageRestrictionBunja } from '@flipster/features/src/margin-bonus/leverage-restriction.state';
import { TextButton } from '@flipster/react/design-system/text-button';
import { TableCell } from '@flipster/ui/Table';

import { openPositionRowDataBunja } from '../row-bunja';
import { useOpenPositionRowActions } from '../use-open-position-row-actions';

const AdjustLeverageCell = memo(() => {
  const { leverageDisplayAtom, isAirdropAtom } = useBunja(openPositionRowDataBunja);
  const leverage = useAtomValue(leverageDisplayAtom);
  const isAirdrop = useAtomValue(isAirdropAtom);
  const { openAdjustLeverageModal } = useOpenPositionRowActions();
  const { leverageRestrictionAtom } = useBunja(leverageRestrictionBunja);
  const { isMaxInitLeverageRestricted } = useAtomValue(leverageRestrictionAtom);

  if (isAirdrop) return <TableCell>-</TableCell>;

  return (
    <TableCell>
      <TextButton
        label={`${leverage}x`}
        color='neutral'
        size='small'
        onClick={openAdjustLeverageModal}
        disabled={isMaxInitLeverageRestricted}
      />
    </TableCell>
  );
});

export default AdjustLeverageCell;
